import { LinkBehaviour } from '../../types/shared.js';

const sitemapLinks = [
  {
    text: "about",
    url: "",
    children: [
      { text: "Register", url: "https://sportsbook.fanduel.com/join" },
      { text: "All Sports", url: "https://sportsbook.fanduel.com/all-sports" },
      { text: "Promotions", url: "https://sportsbook.fanduel.com/promotions" },
      { text: "Support", url: "https://sportsbook.fanduel.com/support" },
      { text: "About Us", url: "https://sportsbook.fanduel.com/about" },
      { text: "FAQs", url: "https://sportsbook.fanduel.com/faq" },
      {
        text: "Betting Guides",
        url: "https://www.fanduel.com/sports-betting-strategy",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Responsible Gaming",
        url: "https://sportsbook.fanduel.com/responsible-gaming"
      },
      { text: "Accessibility", url: "https://www.fanduel.com/accessibility" },
      {
        text: "California Privacy Rights",
        url: "https://fanduelsportsbook.zendesk.com/hc/en-us/articles/360002021707-Privacy-Policy"
      },
      {
        text: "Do Not Sell My Personal Information",
        url: "https://fanduelgroup.formstack.com/forms/ccpa_sb_opt_out",
        behaviour: LinkBehaviour.NewWindow
      }
    ]
  },
  {
    text: "sportsbook odds",
    url: "",
    children: [
      {
        text: "NFL Odds",
        url: "https://sportsbook.fanduel.com/navigation/nfl",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "NFL Team Odds",
        url: "https://sportsbook.fanduel.com/teams/nfl/teams",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "NBA Odds",
        url: "https://sportsbook.fanduel.com/navigation/nba",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "NBA Team Odds",
        url: "https://sportsbook.fanduel.com/teams/nba/teams",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "MLB Odds",
        url: "https://sportsbook.fanduel.com/navigation/mlb",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "NHL Odds",
        url: "https://sportsbook.fanduel.com/navigation/nhl",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "College Football Odds",
        url: "https://sportsbook.fanduel.com/navigation/college-football",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "College Basketball Odds",
        url: "https://sportsbook.fanduel.com/navigation/ncaab",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Soccer Odds",
        url: "https://sportsbook.fanduel.com/soccer",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Golf Odds",
        url: "https://sportsbook.fanduel.com/golf",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "UFC Odds",
        url: "https://sportsbook.fanduel.com/mma",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "NASCAR and F1 Odds",
        url: "https://sportsbook.fanduel.com/motorsport",
        behaviour: LinkBehaviour.NewWindow
      }
    ]
  },
  {
    text: "fanduel group sites",
    url: "",
    children: [
      {
        text: "FanDuel Fantasy",
        url: "https://www.fanduel.com/",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "FanDuel Racing",
        url: "https://racing.fanduel.com/",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "FanDuel Casino",
        url: "https://casino.fanduel.com/",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "TVG",
        url: "https://www.tvg.com/",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "numberFire",
        url: "https://www.numberfire.com/",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "The Duel",
        url: "https://www.fanduel.com/theduel",
        behaviour: LinkBehaviour.NewWindow
      }
    ]
  },
  {
    text: "fanduel apps",
    url: "",
    children: [
      {
        text: "Fantasy (iOS)",
        url: "https://apps.apple.com/app/id599664106?mt=8",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Fantasy (Android)",
        url: "https://www.fanduel.com/android",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Sportsbook (iOS)",
        url: "itms-apps://itunes.apple.com/app/id1413721906",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Sportsbook (Android)",
        url: "https://www.fanduel.com/android-sportsbook",
        behaviour: LinkBehaviour.NewWindow
      }
    ]
  },
  {
    text: "follow fanduel",
    url: "",
    children: [
      {
        text: "Facebook",
        url: "https://www.facebook.com/fanduel/",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Twitter",
        url: "https://twitter.com/fanduel",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Instagram",
        url: "https://instagram.com/fanduel",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "YouTube",
        url: "https://www.youtube.com/channel/UCbPP6F-3ASqkBkT9Obro-TQ",
        behaviour: LinkBehaviour.NewWindow
      },
      {
        text: "Snapchat",
        url: "https://www.snapchat.com/add/fanduel",
        behaviour: LinkBehaviour.NewWindow
      }
    ]
  }
];
const keyLinks = [
  {
    text: "Careers",
    url: "https://www.fanduel.com/careers",
    behaviour: LinkBehaviour.NewWindow
  },
  {
    text: "Security",
    url: "https://www.fanduel.com/security",
    behaviour: LinkBehaviour.NewWindow
  },
  {
    text: "Privacy Policy",
    url: "https://sportsbook.fanduel.com/privacy"
  },
  {
    text: "Terms of Use",
    url: "https://sportsbook.fanduel.com/terms"
  },
  {
    text: "Press & Media",
    url: "https://www.fanduel.com/press",
    behaviour: LinkBehaviour.NewWindow
  }
];
const partnerLinks = [
  {
    text: "numberFire",
    url: "https://www.numberfire.com",
    imageUrl: "/images/numberFire.svg",
    behaviour: LinkBehaviour.NewWindow,
    width: 180,
    height: 23
  },
  {
    text: "21Plus",
    url: "",
    imageUrl: "/images/21-plus.svg",
    width: 23,
    height: 23
  },
  {
    text: "Apple Weather",
    url: "",
    imageUrl: "/images/apple-weather.svg"
  }
];

export { keyLinks, partnerLinks, sitemapLinks };
//# sourceMappingURL=data.js.map
